module.exports = __webpack_public_path__ + "fonts/iconfont.3f509842.woff";